// extracted by css-extract-rspack-plugin
export default {"notFound":"notFound-PZHwg3"};